var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-documents"},[_c('p',{staticClass:"subtitle-text"},[_vm._v(" "+_vm._s(_vm.$t('components.stepper_business.steps.documents'))+" ")]),_c('form-documents',{on:{"submited":_vm.register}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }